<template>
    <app-card-listing-base type="nanny"
                           :hide-actions="hideActions"
                           @recommend="$emit('recommend', item.id)"
                           @auth-dialog="$emit('auth-dialog')"
                           :item="item"
                           :grid="grid">
        <template slot="header">
            <v-layout row class="__header align-center">
                <v-flex class="_box--avatar">
                    <app-avatar :src="item.getAvatarUrl()"></app-avatar>
                </v-flex>
                <v-flex>
                    <app-btn-view-profile :item="item">
                        <h2 class="mb-0 primary--text">{{item.first_name | capitalize}}</h2>
                    </app-btn-view-profile>
                    <p class="mb-0">
                        <span :class="authclass ? 'text-capitalize' : 'blurredobjects text-capitalize'">{{item.postcode.location | capitalize}} | Age
                        {{item.date_birthday | age}}</span>
                        <!--<v-rating v-model="item.rating"
                                  class="d-block app-rating"
                                  dense
                                  size="18"
                                  background-color="success"
                                  color="success"
                                  readonly></v-rating>-->
                    </p>
                </v-flex>
            </v-layout>
        </template>
    </app-card-listing-base>
</template>

<script>
  import AppCardListingBase from './app-card-base'
  import Nanny from '@/models/user/NannyClass'
  import AppAvatar from '../../app-avatar'
  import AppBtnViewProfile from '../../app-buttons/app-btn-view-profile'

  export default {
    name: 'app-card-nanny',

    components: {AppBtnViewProfile, AppAvatar, AppCardListingBase},

    props: {
      hideActions: Boolean,
      grid: Boolean,
      item: [Nanny, Object]
    }, data () {
      return {
        user: null, // <- NannyClass
        authclass:Boolean,
      }
    },
    mounted (){
        if (!this.$auth.check()) {
            this.authclass=false
           
        }else{
            this.authclass=true
        }
    }
  }
</script>

<style lang="stylus" scoped>
    .__header
        ._box--avatar
            max-width 120px
            ._avatar
                width 81px
                height 82px
        .blurredobjects
            text-shadow 0 0 8px #000
            color transparent
            -webkit-user-select none
            -ms-user-select none
            user-select none
    @media (min-width: 600px)
        .__header
            margin-bottom 0px !important
            ._box--avatar
                max-width 168px
            ._avatar
                min-width 132px
                min-height 134px
</style>



// WEBPACK FOOTER //
// src/components/app-card/listing/app-card-nanny.vue